export default __webpack_public_path__ + "static/media/sacredheart.ce47482c.jpg";